var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgClean = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5 1.5L9.83333 8.58333M6.87167 8.2375C4.805 9.03083 3.1525 8.895 1.5 8.24C1.91667 13.6092 4.42 15.6733 7.7575 16.5C7.7575 16.5 10.2717 14.7217 10.6342 10.5058C10.6733 10.0492 10.6925 9.82167 10.5983 9.56417C10.5033 9.30667 10.3167 9.1225 9.94417 8.75333C9.33083 8.14667 9.025 7.84333 8.66083 7.76667C8.29667 7.69167 7.82167 7.87333 6.87167 8.2375Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.75 12.7049C2.75 12.7049 4.83333 13.1083 6.91667 11.4999M8.16667 2.33325V2.41659M6.08333 5.04159C6.08333 5.31785 5.97359 5.5828 5.77824 5.77816C5.58289 5.97351 5.31793 6.08325 5.04167 6.08325C4.7654 6.08325 4.50045 5.97351 4.3051 5.77816C4.10975 5.5828 4 5.31785 4 5.04159C4 4.76532 4.10975 4.50037 4.3051 4.30502C4.50045 4.10967 4.7654 3.99992 5.04167 3.99992C5.31793 3.99992 5.58289 4.10967 5.77824 4.30502C5.97359 4.50037 6.08333 4.76532 6.08333 5.04159Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClean, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clean.1eb80cf5.svg";
export { ForwardRef as ReactComponent };